__turbopack_context__.v({
  "active": "BuySection-module__0ok91W__active",
  "buyH2": "BuySection-module__0ok91W__buyH2",
  "description-container": "BuySection-module__0ok91W__description-container",
  "intro-pricing-banner": "BuySection-module__0ok91W__intro-pricing-banner",
  "lingo-logo": "BuySection-module__0ok91W__lingo-logo",
  "mobileCarouselSection": "BuySection-module__0ok91W__mobileCarouselSection",
  "offerApplied": "BuySection-module__0ok91W__offerApplied",
  "offerFlexContainer": "BuySection-module__0ok91W__offerFlexContainer",
  "offerTag": "BuySection-module__0ok91W__offerTag",
  "offerTagBase": "BuySection-module__0ok91W__offerTagBase",
  "product-types": "BuySection-module__0ok91W__product-types",
  "products": "BuySection-module__0ok91W__products",
  "products-section": "BuySection-module__0ok91W__products-section",
  "root": "BuySection-module__0ok91W__root",
  "title-info-content": "BuySection-module__0ok91W__title-info-content",
  "transparent": "BuySection-module__0ok91W__transparent",
});
